import { Panel } from "./shared";

export const PasswordPanel = ({ action, value, onChange }) => (
  <Panel>
    <input
      type="password"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={action === "protect" ? "Set a password — 4 to 64 characters" : "Enter the document's current password"}
      data-testid="password-input"
      autoComplete="off"
      className="w-full border border-hairline rounded-lg bg-page px-4 py-2.5 font-mono text-xs text-ink placeholder:text-mist focus:outline-none focus:border-azure transition-colors duration-300"
    />
    <p className="font-mono text-[10px] text-mist mt-2" data-testid="password-hint">
      {action === "protect" ? "AES-256 encryption. The password is never stored." : "We decrypt with your password and return a clean copy."}
    </p>
  </Panel>
);
